/**
 * Show details for one Launch Job.
 */
import React from 'react';
import {useParams} from 'react-router';

import {JobDetailContent} from '../components/Launch/JobDetail/JobDetailContent';

export type JobPageProps = {
  entityName: string;
  projectName: string;
  jobId: string;
  jobVersion?: string;
  jobTab?: string;
};

const JobPage = () => {
  const jobPageParams = useParams<JobPageProps>();

  return (
    <JobDetailContent
      entityName={jobPageParams.entityName}
      projectName={jobPageParams.projectName}
      jobId={jobPageParams.jobId}
      jobVersion={jobPageParams.jobVersion}
      jobTab={jobPageParams.jobTab ?? 'runs'}
    />
  );
};

export default JobPage;
